<template>
  <div class="w-100 h-100 orders">
    <header>
      {{ $t('orders.title') }}
      <a-space>
        <a-button type="primary" @click="getOrdersList" v-if="authorities.find(a => a.code === 'after:sale:order:query')">{{ $t('buttons.search') }}</a-button>
        <a-button :loading="addLoading" type="primary" @click="showModal" v-if="authorities.find(a => a.code === 'after:sale:order:create')">{{ $t('buttons.add') }}</a-button>
      </a-space>
    </header>
    <el-table
      style="margin-top: 10px; width: 100%"
      row-key="preemptOrderId"
      v-loading="tableLoading"
      :data="orders"
      :header-cell-style="{ backgroundColor: '#fafafa' }"
    >
      <el-table-column prop="orderNo" width="140">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.code') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="0">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-input @keyup.enter="getOrdersList" v-model.trim="params.orderNo" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.orderNo">
            {{ scope.row.orderNo }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="orderType" width="100">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.type') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="1">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-select  @change="getOrdersList" v-model="params.orderType" style="width: 90%">
            <a-select-option value="">{{ $t('common.all') }}</a-select-option>
            <a-select-option v-for="(v, k) in typeMap" :key="k">
              {{ v }}
            </a-select-option>
          </a-select>
        </template>
        <template slot-scope="scope">
          {{ typeMap[scope.row.orderType] }}
        </template>
      </el-table-column>
      <el-table-column prop="orderState" width="100">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.state') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-select @change="getOrdersList" v-model.trim="params.orderState" style="width: 100%;">
            <a-select-option value="">{{ $t('common.all') }}</a-select-option>
            <a-select-option v-for="(v, k) in stateMap" :key="k">
              {{ v }}
            </a-select-option>
          </a-select>
        </template>
        <template slot-scope="scope">
          <a-dropdown :trigger="['click']" :disabled="!scope.row.orderState">
            <a-button style="padding-left: 0" type="link" :loading="scope.row.loading"><span :style="{ color: stateColors[scope.row.orderState] }">{{ stateMap[scope.row.orderState] }}</span></a-button>
            <a-menu slot="overlay">
              <a-menu-item v-for="(v, k) in stateMap" :key="k" :disabled="k == scope.row.orderState" @click="changeOrderState(k, scope.row)">
                {{ v }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </el-table-column>
      <el-table-column width="90">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.receiver') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-input @keyup.enter="getOrdersList" v-model="params.receiver" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.receiver">
            {{ scope.row.receiver }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="cancelState" width="100">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.cancelState') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-select @change="getOrdersList" v-model="params.cancelState" style="width: 100%;">
            <a-select-option value="0">{{ $t('orders.yes') }}</a-select-option>
            <a-select-option value="1">{{ $t('orders.no') }}</a-select-option>
          </a-select>
        </template>
        <template slot-scope="scope">
          <a-switch @change="showConfirm(scope.row)" v-if="!scope.row.cancelState" :checked-children="$t('orders.yes')" :un-checked-children="$t('orders.cancel')" :checked="!scope.row.cancelState" />
          <span v-else>{{ $t('orders.no') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="company" width="300">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.customer') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-input @keyup.enter="getOrdersList" v-model.trim="params.company" />
        </template>
        <template slot-scope="scope">
          <a
            @click.stop="$router.push({
              path: '/customer/detail',
              query: { id: scope.row.customerId } 
            })"
          >
            <text-highlight :queries="highLightInfo.company">
              {{ scope.row.company }}
            </text-highlight>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="contactPerson" width="100">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.contactPerson') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-input @keyup.enter="getOrdersList" v-model.trim="params.contactPerson" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.contactPerson">
            {{ scope.row.contactPerson }}
          </text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="deviceCode">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.deviceCode') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-input @keyup.enter="getOrdersList" v-model.trim="params.deviceCode" />
        </template>
        <template slot-scope="scope">
          <a @click.stop="gotoDevice(scope.row)">
            <text-highlight :queries="highLightInfo.deviceCode">
              {{ scope.row.deviceCode }}
            </text-highlight>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="deviceName">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.deviceName') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <a-input @keyup.enter="getOrdersList" v-model="params.deviceName" />
        </template>
        <template slot-scope="scope">
            <a @click="getDeviceInfoAndGoroPreview(scope.row.deviceCode)">
              <text-highlight :queries="highLightInfo.deviceName">
                {{ scope.row.deviceName }}
              </text-highlight>
            </a>
          </template>
      </el-table-column>
      <el-table-column prop="orderScore" width="100">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.orderScore') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <!-- <a-input /> -->
        </template>
      </el-table-column>
      <el-table-column prop="finishTime" width="150">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.finishTime') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <!-- <a-input /> -->
        </template>
      </el-table-column>
      <el-table-column prop="note">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.remark') }}
            <!-- <span class="icons unset" style="cursor: pointer;" data-index="2">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span> -->
          </div>
          <!-- <a-input /> -->
        </template>
      </el-table-column>
      <!-- <el-table-column prop="createdAt">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">创建时间<span class="icons unset" style="cursor: pointer;" data-index="0">
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span></div>
            <a-input />
        </template>
      </el-table-column> -->
      <el-table-column width="150">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.operation') }}</div>
        </template>
        <template slot-scope="scope">
          <a-button style="padding-left: 0; margin-left: -3px" type="link" @click="gotoEdit(scope.row)" v-if="authorities.find(a => a.code === 'after:sale:order:update')">{{ $t('modification.details') }}</a-button>
          <a-button :loading="scope.row.readyToRush" style="padding-left: 0; margin-left: -3px" type="link" @click="showRushModal(scope.row)" v-if="authorities.find(a => a.code === 'after:sale:order:rush')">{{ $t('orders.rush') }}</a-button>
          <!-- <a-popconfirm
            title="确认要删除吗?"
            ok-text="确认"
            cancel-text="取消"
          >
            <a-button type="link" style="padding-left: 0">删除</a-button>
          </a-popconfirm> -->
        </template>
      </el-table-column>
    </el-table>
    <a-pagination style="float: right; margin-top: 20px; padding-bottom: 20px" :current="pagination.current" :total="pagination.total" :pageSize="pagination.pageSize" @change="handlePageChange" />
    <OrderModal :visible="visible" :closeModal="closeModal" :orderNo="orderNo" />
    <a-modal :width="800" v-model="rushVisible" :title="$t('orders.rush')" @ok="rush" @cancel="clearRushForm" :confirmLoading="isRushing">
      <a-form-model
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
        style="display: flex; flex-wrap: wrap"
        class="group"
      >
        <div style="width: 50%; display: flex; justify-content: space-between;" class="inline">
          <a-form-model-item style="width: 50%" :label="$t('orders.receiver')">
            <a-select
              v-model="receiver.id"
              show-search
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              @inputKeydown="searchUser"
            >
              <a-select-option @click.native="selectUser(u)" v-for="u in receivers" :key="u.userId">
                {{ u.userName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item style="width: 50%" :label="$t('orders.ratio')">
            <a-input v-model="receiver.ratio" />
          </a-form-model-item>
        </div>
        <div
          v-for="(h, i) in helpers"
          :key="h.id"
          style="width: 50%; display: flex; justify-content: space-between;"
          class="inline"
        >
          <a-form-model-item style="width: 50%" :label="$t('orders.helper')">
            <a-tooltip>
              <template slot="title">{{ $t('buttons.delete') }}</template>
              <a-icon
                type="minus-square"
                style="position: absolute; left: -80px; top: 2px; cursor: pointer; font-size: 16px"
                @click="removeHelper(i)"
              />
            </a-tooltip>
            <a-select
              style="width: 110%"
              show-search
              v-model="h.userId"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              @inputKeydown="searchHelper"
            >
              <a-select-option @click.native="selectHelper(r, i)" v-for="r in orderHelpers" :key="r.userId">{{ r.userName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item style="width: 50%" :label="$t('orders.ratio')">
            <a-input v-model="h.ratio" />
          </a-form-model-item>
        </div>
      </a-form-model>
      <a-button @click="addHelpers" type="primary" icon="plus" style="margin-left: 40px" />
    </a-modal>
  </div>
</template>

<script>
import OrderModal from '@/components/common/OrderModal'
import TextHighlight from "vue-text-highlight"
import { getDict } from '@/api/dict'
import { searchDeviceList } from '@/api/device'
import {
  getOrders,
  createOrderNo,
  setOrderStatus,
  cancelOrder,
  searchOrderOperators
} from '@/api/order'
import { searchReceiver, distribute, searchHelper } from '@/api/operator'
import { nanoid } from 'nanoid'

export default {
  components: {
    OrderModal,
    TextHighlight
  },
  data() {
    return {
      visible: false,
      tableLoading: false,
      addLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      orders: [],
      typeMap: {},
      stateMap: {},
      stateColors: [
        '#e82127',
        '#11d7f5',
        '#11d7f5',
        '#0eed24',
        '#4d4d4d',
        '#4d4d4d',
        '#11d7f5'
      ],
      orderNo: '',
      params: {
        orderNo: '',
        orderType: '',
        orderState: '',
        cancelState: '0',
        company: '',
        contactPerson: '',
        deviceCode: '',
        deviceName: '',
        receiver: ''
      },
      highLightInfo: {
        orderNo: '',
        orderType: '',
        orderState: '',
        cancelState: '',
        company: '',
        contactPerson: '',
        deviceCode: '',
        deviceName: '',
        receiver: ''
      },
      rushVisible: false,
      receivers: [],
      helpers: [],
      receiver: {
        id: '',
        ratio: ''
      },
      orderHelpers: [],
      isRushing: false,
      authorities: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.getOrdersList()
    this.getOperators()
  },
  activated() {
    if (this.$store.state.orderFlag) {
      this.getOrdersList()
    }
    const a = JSON.parse(sessionStorage.getItem("authorities"));
    if (a && a.length) {
      this.authorities = a;
    } else {
      this.authorities = this.getAuthorities(this.$route.path);
    }
  },
  methods: {
    translate() {
      this.setTypeAndStateMap()
    },
    async showModal() {
      this.addLoading = true
      try {
        const { data } = await createOrderNo()
        this.orderNo = data 
      } catch(e) {
        console.log(e)
      } finally {
        this.addLoading = false
        this.visible = true
      }
    },
    async getOperators(userName = '') {
      try {
        const { data } = await searchReceiver({
          userName
        });
        this.receivers = data;
      } catch (e) {
        console.log(e);
      }
    },
    addHelpers() {
      this.helpers.push({
        id: nanoid()
      })
    },
    removeHelper(i) {
      this.helpers.splice(i, 1)
    },
    closeModal(flag) {
      if (flag) {
        this.getOrdersList()
      }
      this.visible = false
      this.orderNo = ''
    },
    async getOrdersList() {
      this.tableLoading = true
      try {
        const { data } = await getOrders(this.pagination.current, this.pagination.pageSize, this.params)
        this.orders = data.records
        for (let k in this.highLightInfo) {
          this.highLightInfo[k] = this.params[k]
        }
        this.pagination.current = data.current
        this.pagination.total = data.total
      } catch(e) {
        console.log(e)
      } finally {
        this.tableLoading = false
      }
    },
    async setTypeAndStateMap() {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      try {
        let map = {}
        const type = await getDict(lang, 'afterSaleServerItem')
        type.data.content.forEach(c => {
          map[c.value] = c.text
        })
        this.typeMap = map
        map = {}
        const state = await getDict(lang, 'afterSaleOrderStatus')
        state.data.content.forEach(c => {
          map[c.value] = c.text
        })
        this.stateMap = map
      } catch(e) {
        console.log(e)
      }
    },
    gotoDevice(device) {
      this.$store.commit('setDeviceInfo', device.deviceCode)
      this.$router.push('/equipment/list/submit/edit')
    },
    async getDeviceInfoAndGoroPreview(code) {
      try {
        const { data } = await searchDeviceList(1, 10, {
          query: [],
          filter: [
            {
              field: 'code',
              value: code
            }
          ],
          sort: []
        })

        const device = data.records[0]
        this.$router.push({
          path: '/equipment/preview',
          query: {
            code: device.code,
            name: device.name,
            driver: device.driverType,
            pc: device.protocolCode,
            type: device.type,
            id: device.id,
            ci: device.customer ? device.customer.id : ''
          }
        })
      } catch(e) {
        console.log(e)
      }
    },
    gotoEdit(row) {
      this.$router.push({
        path: '/order/detail',
        query: {
          orderNo: row.orderNo,
          orderType: row.orderType,
          note: row.note,
          orderScore: row.orderScore,
          customerId: row.customerId,
          deviceId: row.deviceId,
          preemptOrderId: row.preemptOrderId,
          orderState: row.orderState
        }
      })
    },
    async changeOrderState(orderState, row) {
      row.loading = true
      this.orders = [...this.orders]
      try {
        const { message } = await setOrderStatus({
          preemptOrderId: row.preemptOrderId,
          orderState
        })
        this.$message.success(message)
        this.getOrdersList()
      } catch(e) {
        console.log(e)
      } finally {
        row.loading = false
        this.orders = [...this.orders]
      }
    },
    handlePageChange(p) {
      this.pagination.current = p
      this.getOrdersList()
    },
    async showConfirm(row) {
      if (!this.authorities.find(a => a.code === 'after:sale:order:cancel')) {
        return this.$message.warn(this.$t('messages.np'))
      }
      this.$confirm({
        title: this.$t('orders.confirmTitle'),
        content: this.$t('orders.clickToConfirm'),
        onOk: async () => {
          try {
            const { message } = await cancelOrder({
              preemptOrderId: row.preemptOrderId,
              cancelState: 1
            })
            this.$message.success(message)
            this.getOrdersList()
          } catch(e) {
            console.log(e)
          }
        }
      })
    },
    searchUser(e) {
      if (e.code === 'Enter') {
        e.target.value = e.target.value.trim()
        this.getOperators(e.target.value)
      }
    },
    async showRushModal(row) {
      row.readyToRush = true
      try {
        await this.getHelpers()
        const { data } = await searchOrderOperators({
          preemptOrderId: row.preemptOrderId
        })
        data.forEach(d => {
          if (d.orderRole === 1) {
            this.receiver.id = d.userId;
            this.receiver.ratio = d.orderRate
          }
          if (d.orderRole === 2) {
            this.helpers.push({
              ...d,
              id: nanoid(),
              ratio: d.orderRate
            })
          }
        })
        this.orderId = row.preemptOrderId
        this.rushVisible = true
      } catch(e) {
        console.log(e)
      } finally {
        row.readyToRush = false
      }
    },
    selectUser(u) {
      if (u.userId === this.receiver.id) return
      this.receiver.ratio = u.ratio
      this.helpers = u.assistant.map(a => {
        return {
          ...a,
          id: nanoid()
        }
      })
    },
    async getHelpers(userName = '') {
      try {
        const { data } = await searchHelper({
          userName
        })
        this.orderHelpers = data
      } catch(e) {
        console.log(e)
      }
    },
    searchHelper(e) {
      if (e.code === "Enter") {
        e.target.value = e.target.value.trim();
        this.getHelpers(e.target.value)
      }
    },
    selectHelper(r, i) {
      this.helpers[i] = {
        id: this.helpers[i].id,
        ...r
      }
    },
    async rush() {
      this.isRushing = true
      let result = +this.receiver.orderRate
      for (let i = 0; i < this.helpers.length; i++) {
        result += +this.helpers[i].ratio
      }
      if (result > 100) {
        return this.$message.warn(this.$t('orders.unreasonableDistribution'))
      }
      try {
        const os = []
        os.push({
          orderId: this.orderId,
          userId: this.receiver.id,
          orderRole: 1,
          orderRate: this.receiver.ratio
        })
        for (let i = 0; i < this.helpers.length; i++) {
          const h = this.helpers[i]
          os.push({
            orderId: this.orderId,
            userId: h.userId,
            orderRole: 2,
            orderRate: h.ratio
          })
        }
        const { message } = await distribute(os)
        this.$message.success(message);
        this.rushVisible = false
        this.clearRushForm()
        this.getOrdersList()
      } catch(e) {
        console.log(e)
      } finally {
        this.isRushing = false
      }
    },
    clearRushForm() {
      this.receiver = {
        id: '',
        orderRate: ''
      },
      this.helpers = []
      this.orderHelpers = []
    }
  }
}
</script>

<style lang="less" scoped>
.orders {
  padding: 15px;
  header {
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  span {
    position: relative;
  }
  .anticon-caret-up {
    position: absolute;
    top: -1px;
    right: -18px;
    font-size: 14px;
    color: #ccc;
  }
  span.ASC .anticon-caret-up {
    color: #1890ff;
  }
  span.icons {
    position: absolute;
    right: 18px;
  }
  span.DESC .anticon-caret-down {
    color: #1890ff;
  }
  .anticon-caret-down {
    position: absolute;
    top: 8px;
    right: -18px;
    font-size: 14px;
    color: #ccc;
  }
}
/deep/.ant-form {
  padding-bottom: 0;
  &.inline {
    .ant-form-item:last-child .ant-form-item-label {
      width: 15%;
      margin-right: 6px;
    }
  }
}
/deep/ .ant-modal-body {
  padding-bottom: 20px;
  padding-right: 60px;
}
/deep/ .ant-select-selection-selected-value {
  font-weight: normal !important;
}
</style>